// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../dealer-transfer-history/state/criteria';
import actions from '../../actions-list';

const updateDealerTransferHistoryCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const resetDealerTransferHistoryCriteria = state =>
    Criteria.update(state, {
        historyToDisplay: {
            $set: null
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DEALER_TRANSFER_HISTORY_CRITERIA]: updateDealerTransferHistoryCriteria,
        [actions.RESET_DEALER_TRANSFER_HISTORY_CRITERIA]: resetDealerTransferHistoryCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/reducers/criteria.js